import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthService, Country } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CmsNavigationComponent } from '../../../../core/model';
import { SiteCountryService } from '../../../../core/site-context';
import { WindowRef } from '../../../../core/window';
import { DrawerService, DrawerWidth } from '../../../../shared';
import { NavigationService } from '../navigation';
import { BaseSiteNavigationNode, NavigationNode } from '../navigation/navigation-node.model';

@Component({
  selector: 'py-country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss'],
  standalone: false,
})
export class CountrySelectorComponent implements OnInit {
  activeCountry$: Observable<Country>;

  @ViewChild('countrySelectorDrawerTemplate') countrySelectorDrawerTemplate: TemplateRef<any>;

  node$: Observable<NavigationNode>;

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private navigationService: NavigationService,
    private drawerService: DrawerService,
    private authService: AuthService,
    private siteCountryService: SiteCountryService,
    protected windowRef: WindowRef
  ) {}

  ngOnInit(): void {
    this.node$ = this.navigationService.createNavigation(this.componentData.data$);
    this.activeCountry$ = this.siteCountryService.getActiveCountry();
  }

  openDrawer(): void {
    this.drawerService
      .open({ template: this.countrySelectorDrawerTemplate, width: DrawerWidth.Default })
      .pipe(take(1))
      .subscribe();
  }

  logoutAndRedirectToBaseSite(url: string): void {
    this.authService
      .isUserLoggedIn()
      .pipe(take(1))
      .subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this.authService.coreLogout().finally(() => {
            this.redirectToBaseSite(url);
          });
        } else {
          this.redirectToBaseSite(url);
        }
      });
  }

  handleClick(site: BaseSiteNavigationNode, activeCountry: Country) {
    if (!this.isSelected(site, activeCountry)) {
      if (site?.toCurrentBaseSite) {
        this.siteCountryService.overrideCountry(activeCountry?.isocode, {
          countryFlagSprite: site?.countryFlagSprite,
          name: site?.title,
        });
      } else {
        this.logoutAndRedirectToBaseSite(Array.isArray(site?.url) ? site.url[0] : site?.url);
      }
    }
  }

  isSelected(site: BaseSiteNavigationNode, activeCountry: Country): boolean {
    return site?.toCurrentBaseSite && site?.countryFlagSprite === activeCountry?.countryFlagSprite;
  }

  private redirectToBaseSite(url: string): void {
    if (this.windowRef.isBrowser()) {
      this.windowRef.nativeWindow.location.href = url;
    }
  }
}
